import React, { useEffect } from "react";
import { IonCheckbox, IonContent, IonHeader, IonItem, IonList, IonPage, IonPopover, IonTitle, IonToolbar } from "@ionic/react";
import { useState } from "react";
import { CloseCircle, Container, ImgContainer, ImgItem, PickerImgItem, StyledLink, TopRow } from "./style";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Button from "@material-ui/core/Button";
import PhotoGallery from "../../components/PhotoGallery";
import ImageOption from "../../components/ImageOption";
import { usePhotoGallery } from "../../hooks/usePhotoGallery";
import { Loading } from "../../components/Loading";
import { ErrorToast, SuccessToast } from "../../components/toast";
import DrawModal from "../../components/DrawModal";
import { authenticateToken, authenticateUser, itsMe, logOut, uploadImages } from "../../services/api.service";
// import * as DbService from "../../services/database.service";
import "./style.css";
import { AuthenticationDialog } from "../../components/Dialog";
import * as storage from "../../utils/storage";
import { emptyAuthObj } from "../../utils/authutil";
import { InputLabel, TextField } from "@material-ui/core";
import { BsPower, BsThreeDotsVertical } from "react-icons/bs";

const Photos = () => {
  const [selectedImages, setSelectedImages] = useState<any[]>([]);
  const [showPreview, setShowPreview] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [count, setCount] = useState(false);
  const [openAuthenticationDialog, setOpenAuthenticationDialog] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [qrCodeText, setQrCodeText] = useState("");
  const [authenticateStatus, setAuthenticateStatus] = useState("Not Authenticated");
  const [sbosIdText, setSbosIdText] = useState("");
  const [popoverState, setShowPopover] = useState({ showPopover: false, event: undefined });
  const [homePageSettings, setHomePageSettings] = useState<any>({
    save_photos_to_gallery: false, auto_attach_photos: true
  });
  const [isEditImage, setIsEditImage] = useState(false);
  const [editImageObj, setEditImageObj] = useState<any>([]);
  const [editImageIndex, setEditImageIndex] = useState(0);

  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get("token");
  const urlRefId = urlParams.get("ref_id");

  const [values, setValues] = useState({
    contentHeight: "80%",
    footerHeight: "20%",
    imageOptionStatus: false,
  });

  React.useEffect(() => {
    (async () => {
      console.log({urlToken, urlRefId})
      if(urlRefId) {
        setSbosIdText( urlRefId );
      }
      if (urlToken) {
        authenticateUrlToken(urlToken);
      } else {
        const token = await storage.get(storage.KEYS.LOGIN_TOKEN);
        if (token) {
          setAuthenticateStatus("");
        }
      }
      let settings: any = await storage.get(storage.KEYS.HOME_PAGE_SETTINGS);
      console.log({settings});
      if(settings) {
        settings = JSON.parse(settings);
        setHomePageSettings(settings);
      }
    })();
  }, []);

  const { photos, takePhoto } = usePhotoGallery();
  useEffect(() => {
    console.log({count})
    if (count) {
      setShowModal(true);
    } else {
      setCount(true);
    }
    setMultiplePhotos();
  }, [photos]);

  const setMultiplePhotos = async () => {
    try {
      if (photos.length > 1) {
        let temp = [...selectedImages];
        for (let i = 0; i < photos.length; i++) {
          const img: any = photos[i];
          img.img = photos[i].base64;
          temp.push(img);
        }
        await updateImages(temp);
      }
    } catch (error) {
      console.error(error);
      setToastMsg("Set multiple photos is failed. " + error);
      setShowErrorToast(true);
    }
  };

  const deletePhoto = (item: any, index: any) => {
    setLoading(true);
    let temp = [...selectedImages];
    temp.splice(index, 1);
    updateImages(temp);
  };

  const updateImages = async (images: any) => {
    console.log('updateImages', images)
    setLoading(true);
    setSelectedImages(images);
    if(images.length > 0) {
      // await DbService.replaceUploadedPhotos(images, new Date());
    }
    setLoading(false);
  };

  const handleImageOptions = () => {
    setValues({
      ...values,
      imageOptionStatus: !values.imageOptionStatus,
    });
  };

  const handleSelectFromOption = async (bol: any, selectedOption: any, files: any = []) => {
    try {
      setLoading(true);
      await takePhoto(bol, selectedOption, files);
      setLoading(false);
    } catch (err: any) {
      console.error(err);
      setLoading(false);
      setToastMsg("Failed to select photos. Please try again.");
      setShowErrorToast(true);
    }
  };

  async function uploadPhotos() {
    const token = await storage.get(storage.KEYS.LOGIN_TOKEN);
    console.log({ token });
    if (token) {
      console.log({selectedImages})
      if (selectedImages.length > 0) {
        setLoading(true);
        const body: any = { transactions: [] };
        selectedImages.forEach((element: any) => {
          if (!element.id) {
            const obj: any = {
              image: element.img,
              date: new Date(),
              sbos_id_or_q_id: sbosIdText,
              auto_attach_photos: homePageSettings.auto_attach_photos
            };
            body.transactions.push(obj);
          }
        });
        if (body.transactions.length === 0) {
          setLoading(false);
          return;
        }
        console.log({body})
        uploadImages(body)
          .then(async (res) => {
            setLoading(false);
            if (res.response.status === "200") {
              setToastMsg("Successfully Uploaded the photos.");
              setShowToast(true);
              setSelectedImages([]);
            } else {
              setToastMsg(res.response.status + ": " + res.response.msg);
              setShowErrorToast(true);
            }
          })
          .catch((err) => {
            console.error(err);
            setLoading(false);
            setToastMsg("Photo uploading is failed.");
            setShowErrorToast(true);
          });
      }
    } else {
      setAuthenticateStatus("Not Authenticated");
      setToastMsg("User is not authenticated.");
      setShowErrorToast(true);
    }
  }

  const imagePicker = (photo: any) => {
    setShowModal(!showModal);
    let temp = [...selectedImages];
    const obj = { img: photo.base64, base64: photo.base64, webviewPath: photo.webviewPath };
    temp.push(obj);
    updateImages(temp);
  };

  const handleClose = () => {
    console.log("closed");
    setOpenAuthenticationDialog(false);
  };


  const authenticateUrlToken = (token: any) => {
    setLoading(true);
    setOpenAuthenticationDialog(false);
    const body = {
      token: token,
    };
    console.log(body);
    authenticateToken(body)
      .then(async (res) => {
        console.log("auth", res);
        handleAuthenticationResponse(res);
        setLoading(false);
      })
      .catch((err) => {
        alert('error' + err)
        setLoading(false);
        console.error(err);
        setToastMsg("User login failed. " + JSON.stringify(err));
        setShowErrorToast(true);
        setAuthenticateStatus("Not Authenticated");
      });
  };

  const authenticate = (qrAuthCode: any = '') => {
    if (loginSuccess === false) {
      // setToastMsg("User authentication is failed.");
      // setShowErrorToast(true);
      // return;
    }
    if(qrAuthCode == '') {debugger;
      qrAuthCode = qrCodeText;
    }

    setLoading(true);
    setOpenAuthenticationDialog(false);
    const body = {
      user: { one_time_password: qrAuthCode },
    };
    console.log(body);
    authenticateUser(body)
      .then(async (res) => {
        console.log("auth", res);
        handleAuthenticationResponse(res);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        setToastMsg("User login failed. " + JSON.stringify(err));
        setShowErrorToast(true);
        setAuthenticateStatus("Not Authenticated");
      });
  };

  const setSbosId = (val: any) => {
    console.log(val)
    setSbosIdText(val);
  }

  const handleAuthenticationResponse = async (res : any) => {
    if (res.response.status === "200") {
      const payload = res.response.result;
      await storage.set(storage.KEYS.LOGIN_TOKEN, payload.token);
      await storage.set(storage.KEYS.USERNAME, payload.username);
      await storage.set(storage.KEYS.AUTH_OBJ, JSON.stringify(payload));
      const itsmeResult = await itsMe({});
      if (itsmeResult.response.status === "200" && itsmeResult.response.result.msg === "Ok") {
        setAuthenticateStatus("");
        setToastMsg("Successfully Authenticated.");
        setShowToast(true);
        // alert(urlRefId)
        window.location.href = '/photos' + (urlRefId ? ("?ref_id=" + urlRefId) : "");
      } else {
        setToastMsg("its me login failed. " + itsmeResult.response.status + ": " + itsmeResult.response.msg);
        setShowErrorToast(true);
        setAuthenticateStatus("Not Authenticated");
      }
    } else {
      console.error(res);
      setToastMsg(res.response.status + ": " + res.response.msg);
      setShowErrorToast(true);
      setAuthenticateStatus("Not Authenticated");
      logOut({}).then((res) => {
        emptyAuthObj();
      });
    }
  };

  const changeHomePageSettings = (type: string) => {
    if(!homePageSettings) {
      setHomePageSettings({save_photos_to_gallery: false, auto_attach_photos: false});
    }
    if(type === "SAVE_PHOTOS_TO_GALLERY"){
      homePageSettings.save_photos_to_gallery = !homePageSettings.save_photos_to_gallery;
    } else if(type === "AUTO_ATTACH_PHOTOS") {
      homePageSettings.auto_attach_photos = !homePageSettings.auto_attach_photos;
    }
    storage.set(storage.KEYS.HOME_PAGE_SETTINGS, JSON.stringify(homePageSettings));
    setShowPopover({ showPopover: false, event: undefined });
  };

  const editImage = (i: any) => {
    console.log(i, selectedImages[i])
    setIsEditImage(true);
    const tmp = [selectedImages[i]];
    setEditImageObj(tmp);
    setEditImageIndex(i);
  }

  const editImagePicker = async (photo: any) => {
    setIsEditImage(false);
    let temp = [...selectedImages];
    let tmpImg = photo;
    tmpImg.img = photo.base64;
    temp[editImageIndex] = tmpImg;
    setLoading(true);
    // await DbService.replaceUploadedPhotos(temp, new Date());
    setSelectedImages(temp);
    setLoading(false);
  };

  const logout = () => {
    setAuthenticateStatus("Not Authenticated");
    logOut({}).then((res) => {
      emptyAuthObj();
      location.reload();
    });
  }

  return (
    <IonPage>
      {showModal && photos.length === 1 ? (
        <Container>
          <DrawModal imgData={photos[0]} onSave={imagePicker} />
        </Container>
      ) :
      isEditImage ? (
        <Container>
          <DrawModal imgData={editImageObj[0]} onSave={editImagePicker} />
        </Container>
      ) :
      (
        <>
          <IonHeader>
            <IonToolbar>
              <IonTitle>
                <p>Photos</p>

                <p className="settings">
                  {authenticateStatus == "" && 
                  <BsPower onClick={logout} className="logout_class" title="Logout" />
                  }
                  <BsThreeDotsVertical onClick={
                  (e: any) => {
                    e.persist();
                    setShowPopover({ showPopover: true, event: e })
                  }} color="#000000"/>

                  <IonPopover
                    cssClass='my-custom-class'
                    event={popoverState.event}
                    isOpen={popoverState.showPopover}
                    onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })} >
                    <IonList>
                      {/* <IonItem button onClick={() => changeHomePageSettings("SAVE_PHOTOS_TO_GALLERY")}> <IonCheckbox checked={homePageSettings?.save_photos_to_gallery} />&nbsp;Save photos to gallery</IonItem> */}
                      <IonItem button onClick={() => changeHomePageSettings("AUTO_ATTACH_PHOTOS")} title="Attach photos to the given order id"> <IonCheckbox checked={homePageSettings?.auto_attach_photos} />&nbsp;Auto attach photos</IonItem>
                    </IonList>
                  </IonPopover>
                </p>
                
                {authenticateStatus != "" && 
                <p
                  className="auth_status"
                  onClick={() => {
                    setOpenAuthenticationDialog(true);
                  }}
                >
                  {authenticateStatus}. Click to Login. 
                </p>
                }

              </IonTitle>
            </IonToolbar>

          </IonHeader>
          <IonContent fullscreen>
            <IonHeader collapse="condense">
              <IonToolbar>
                <IonTitle size="large">Photos</IonTitle>
              </IonToolbar>
            </IonHeader>

            <TopRow>
              <PickerImgItem onClick={() => handleImageOptions()}>+</PickerImgItem>
            </TopRow>
            <ImgContainer>
              {selectedImages && selectedImages.length > 0 && selectedImages.map((item: any, index: any) => (
                <>
                  <ImgItem key={"imgItem" + index}>
                    <img
                      src={item.img}
                      width="100%"
                      height="100%"
                      alt=""
                      onClick={(e: any) => {
                        setShowPreview(true);
                      }}
                    />
                  </ImgItem>
                  {
                    <CloseCircle onClick={() => deletePhoto(item, index)} key={"deleteIcon" + index}>
                      <AiOutlineCloseCircle style={{ width: "1.5rem", height: "1.5rem" }} />
                    </CloseCircle>
                  }
                </>
              ))}
            </ImgContainer>
            <br/>
            <InputLabel style={{ marginLeft: "1rem"}}>SBOS Id or Q Id (use S or Q prefix with the id)</InputLabel>
            <TextField autoFocus margin="dense" id="sbosId" type="text"  placeholder="Sbos id / Q id"  style={{ marginLeft: "1rem"}} value={sbosIdText}
              onChange={(e) => setSbosId(e.target.value)} />
            <br/>
            {selectedImages && selectedImages.length > 0 && (
              <Button variant="contained" color="primary" onClick={() => uploadPhotos()} style={ { marginLeft: "1rem"}}>
                <StyledLink>Upload</StyledLink>
              </Button>
            )}
            {selectedImages && selectedImages.length > 0 && (
              <PhotoGallery
                title={"Preview"}
                isOpen={showPreview}
                images={selectedImages}
                slideOpts={{ initialSlide: 1, speed: 400 }}
                onClose={() => {
                  setShowPreview(false);
                }}
                setShowPreview={setShowPreview}
                editImage={(i: any) => {editImage(i)}}
              ></PhotoGallery>
            )}

            <ImageOption bottom={values.imageOptionStatus} onChange={handleImageOptions} imagePicker={handleSelectFromOption} />
          </IonContent>
        </>
      )}
      <AuthenticationDialog open={openAuthenticationDialog} onClose={handleClose} setQrCodeText={setQrCodeText} setLoginSuccess={setLoginSuccess} authenticate={(qrcode) => authenticate(qrcode)} />
      <Loading showLoading={isLoading} backdropDismiss={true} />
      <ErrorToast showToast={showErrorToast} setShowToast={setShowErrorToast} msg={toastMsg} />
      <SuccessToast showToast={showToast} setShowToast={setShowToast} msg={toastMsg} />
    </IonPage>
  );
};

export default Photos;
